<template>
  <div>
    <div class="normalHeader" >
      <img src="@/assets/img_gywm.png" class="bg" />
    </div>
    <div class="panel">
      <div class="w1200">
        <div class="breader">
          <router-link to="/" class="breaderLink">首页</router-link>
          <span> / </span>
          <span class="breaderNow">新闻中心</span>
        </div>
        <div class="newsList" v-if="isReady">
          <router-link v-for="(item, index) in list" :key="'news'+index" target="_blank"
            :to="'/xwzxDetail/'+item.id" class="newsItem">
            <img :src="item.banner" class="pic" />
            <div class="flexItem">
              <div class="title">{{item.title}}</div>
              <div class="info">{{item.description}}</div>
              <div class="date">{{item.releaseTime}}</div>
            </div>
          </router-link>
          <div class="nullTip" v-if="list.length == 0">
            暂无信息
          </div>
          <el-pagination
            @current-change="pageLoad"
            :current-page="page"
            :page-size="10"
            background
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'xwzx',
  components: {
  },
  data() {
    return {
      routerFrom: {},
      routerTo: {},
      isReady: false,
      page: 1,
      total: 0,
      list: []
    }
  },
  watch: {
    $route(to, from) {
      this.routerFrom = from
      this.routerTo = to
      console.log(this.routerTo)
    }
  },
  mounted() {
    this.page = 1
    this.init()
  },
  methods: {
    init() {
      let _this = this
      _this.isReady = false
      _this.$axios({
        method: 'get',
        url: _this.$base + 'api/article/getArticleList',
        params: { // get params / post data
          baseId	: 'www',
          categoryId: 'list',
          pageNum: _this.page,
          pageSize: 10
        }
      }).then((res)=>{
        console.log(res)
        _this.total = res.data.total
        _this.list = res.data.rows
        _this.isReady = true
      }).catch((err)=>{
        console.log(err)
        _this.isReady = true
      })
    },
    pageLoad(currentPage){
      this.page = currentPage
      this.init()
    }
  }
}
</script>

<style scoped>
* {box-sizing: border-box;}
.normalHeader{width: 100%;height: 260px;}
.normalHeader .bg{display: block;width: 100%;height: 100%;object-fit: cover;}
.panel{width: 100%;height: auto;position: relative;padding-bottom: 100px;background-color: #F8F9FD;}
.w1200{width: 1200px;margin: 0 auto;}
.breader{padding-top: 30px;padding-bottom: 60px;}
.breader span{display: inline-block;color: #8C8C8C;font-size: 14px;line-height: 20px;margin-left: 8px;margin-right: 8px;}
.breader .breaderLink{display: inline-block;color: #8C8C8C;font-size: 14px;line-height: 20px;margin: 0;}
.breader .breaderLink:hover{color: #0E4AFA}
.breader .breaderNow{display: inline-block;color: #151515;font-size: 14px;line-height: 20px;margin: 0;}
.el-pagination{text-align: center;margin-top: 60px;}
.newsItem{background-color: #fff;width: 1200px;border-radius: 10px;box-shadow: 0px 0px 14px 0px rgba(78,112,163,0.2);padding: 40px;display: flex;flex-direction: row;align-items: center;position: relative;margin-bottom: 40px;}
.newsItem .pic{width: 370px;height: 242px;object-fit: cover;display: inline-block;margin-right: 32px;}
.newsItem .flexItem{flex:1;width: 0;}
.newsItem .title{color: #222;font-size: 28px;font-weight: bold;line-height: 50px;margin-bottom: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.newsItem .info{color: #666;font-size: 18px;line-height: 30px;height: 90px;text-align: justify;
  overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;word-wrap: break-word;-webkit-hyphens: auto;hyphens: auto;
}
.newsItem .date{color: #666;font-size: 14px;line-height: 20px;margin-top: 32px;}
.newsItem:hover .title{color: #0E4AFA}
</style>
